import React from 'react';
import ImgError from './img-error.png';
import { IconLoading } from '../IconLoading';

interface Props {
  error?: boolean;
  text?: string;
}

function PageLoading({ error, text = '数据加载中' }: Props) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black">
      {error ? (
        <img src={ImgError} style={{ width: 125, height: 134 }} alt="" />
      ) : (
        <div className="flex flex-col items-center">
          <IconLoading size={100} />
          <div className="mt-15 text-black-gray">{text}</div>
        </div>
      )}
    </div>
  );
}

export default PageLoading;
